import { render, staticRenderFns } from "./EmailTemplates.vue?vue&type=template&id=52900f94&scoped=true"
import script from "./EmailTemplates.vue?vue&type=script&lang=js"
export * from "./EmailTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52900f94",
  null
  
)

export default component.exports